// Third-party
import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Icon from '@mdi/react';
import { mdiArrowLeftThin } from '@mdi/js';

// Components
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import { FC, useState } from 'react';
import { Iconify, Logo } from '@mgm/common/components';
import { BaseTooltip, GenericHeader } from '@mgm/common/components/base';
import { LanguageSelect } from '../../../components';
import { useAppSelector } from '../../../hooks/useAppStore';
import { getInviteMembers } from '../../../store/onboarding/selector';
import { AddMembersDialog } from './AddMembersDialog';
import { ROUTES } from '../../../data';

type TInviteTeamHeader = {
  handleStartTour: () => void
};

const InviteTeamHeader: FC<TInviteTeamHeader> = ({ handleStartTour }) => {
  const { t } = useTranslation(['welcome', 'common', 'team']);
  const navigate = useNavigate();
  const teamMembers = useAppSelector(getInviteMembers);
  const [isOpenDialog, setIsOpenDialog] = useState(false);

  const onSkip = () => {
    navigate(ROUTES.TEAM);
  };

  const inviteMembers = () => {
    setIsOpenDialog(true);
  };

  return (
    <>
      <Grid
        alignItems="center"
        paddingY={2}
        container
        justifyContent="space-between"
      >
        <Grid size={{
          lg: 12,
          md: 12,
          xs: 12,
          sm: 12,
        }}
        >
          <Box
            sx={{
              display: 'inline-flex',
              height: 60,
              width: 60,
            }}
          >
            <Logo />
          </Box>
          <LanguageSelect />
        </Grid>
        <Grid sx={{ mt: 2 }}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <GenericHeader
              titleProps={{
                children: t('inviteYourTeamMembers', { ns: 'team' }),
              }}
              sx={{ mb: 0 }}
            />
            <BaseTooltip tooltipText={t('clockHereToStartAGuided', { ns: 'common' })}>
              <Box
                sx={{
                  cursor: 'pointer',
                }}
                alignItems="center"
                display="flex"
                onClick={handleStartTour}
              >
                <Iconify icon="cuida:help-outline" width={24} sx={{ color: '#A855F7' }} />
              </Box>
            </BaseTooltip>
          </Stack>
        </Grid>
        <Grid display="flex" alignItems="center">
          <Stack spacing={2} paddingTop={2} direction="row" justifyContent="start">
            <Button id="skip-invite" onClick={onSkip} variant="outlined">
              <Icon className="mr-1" path={mdiArrowLeftThin} size={0.7} />
              {t('skipForNow', { ns: 'common' })}
            </Button>
            <Button id="invite-members" disabled={teamMembers.length === 0} onClick={inviteMembers} variant="contained">
              {t('inviteMembers', { ns: 'team' })}
            </Button>
          </Stack>
        </Grid>
      </Grid>
      <AddMembersDialog setIsOpenDialog={setIsOpenDialog} isOpenDialog={isOpenDialog} />
    </>
  );
};

export {
  InviteTeamHeader,
};
